import axiosInstance from '../../lib/axios';

const ROOT = '/devices';

export const fetchDevices = async ({ page = 1, limit = 20, serialNumber, type } = {}) => {
  const params = { page, limit };
  if (serialNumber) params.serial_number = serialNumber;
  if (type) params.type = type;
  const response = await axiosInstance.get(`${ROOT}/`, { params });
  return response.data;
};

export const fetchDevice = async (deviceId) => {
  const response = await axiosInstance.get(`${ROOT}/${deviceId}/`);
  return response.data;
};

export const createDevice = async (payload) => {
  const response = await axiosInstance.post(`${ROOT}/`, payload);
  return response.data;
};

export const updateDevice = async (deviceId, patch) => {
  const response = await axiosInstance.patch(`${ROOT}/${deviceId}/`, patch);
  return response.data;
};

export const deleteDevice = async (deviceId) => {
  const response = await axiosInstance.delete(`${ROOT}/${deviceId}/`);
  return response.data;
};

export const linkCharger = async (deviceId, chargerId) => {
  const response = await axiosInstance.put(`${ROOT}/${deviceId}/charger/`, {
    charger_id: chargerId,
  });
  return response.data;
};

export const unlinkCharger = async (deviceId) => {
  await axiosInstance.delete(`${ROOT}/${deviceId}/charger/`);
};

export const fetchUserDeviceLinks = async ({ page = 1, limit = 20, deviceId } = {}) => {
  const params = { page, limit };
  if (deviceId) params.device_id = deviceId;
  const response = await axiosInstance.get(`${ROOT}/users/`, { params });
  return response.data;
};

// Account facts plus current devices, in { success, data }. A 404 also covers malformed ids.
// firmware.latest can be lower than current: an approved rollback shows as an update.
export const fetchUserDeviceCard = async (userId) => {
  const response = await axiosInstance.get(`${ROOT}/users/${userId}/`);
  return response.data;
};
